/**
 *
 * Checks whether search data has changed from the previous data object
 * Can be used to determine whether a new call to the API is needed, for example
 *
 * @param {Object} newData The latest data object
 * @param {Object} prevData The previous data object
 * @param {Object} options
 * @param {Object} options.isGeoSearch - Whether it's a geolocation based search
 * @param {Object} options.compareOnLastSuccess - Whether to use the "last success" keys as a comparison
 *
 * @return Boolean
 */
export const hasDataChanged = (newData, prevData, options) => {
  const {isGeoSearch, compareOnLastSuccess} = options
  const searchTermKey = compareOnLastSuccess ? "lastSuccessfulQ" : "q"
  const hasSearchTermChanged = newData[searchTermKey] !== prevData[searchTermKey]
  const latKey = compareOnLastSuccess ? "lastSuccessfulLat" : "lat"
  const hasLatChanged = isGeoSearch ? newData[latKey] !== prevData[latKey] : false
  const lngKey = compareOnLastSuccess ? "lastSuccessfulLng" : "lng"
  const hasLngChanged = isGeoSearch ? newData[lngKey] !== prevData[lngKey] : false
  const radiusKey = compareOnLastSuccess ? "lastSuccessfulRadius" : "radius"
  const hasRadiusChanged = isGeoSearch ? newData[radiusKey] !== prevData[radiusKey] : false
  const boundingBoxKey = compareOnLastSuccess ? "lastSuccessfulBoundingBox" : "boundingBox"
  const hasBoundingBoxChanged = isGeoSearch ? newData[boundingBoxKey] !== prevData[boundingBoxKey] : false
  return hasSearchTermChanged || hasLatChanged || hasLngChanged || hasRadiusChanged || hasBoundingBoxChanged
}
